









import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { CloseButton } from '@/components/Base';

@Component({
  components: {
    CloseButton,
  },
})
export default class Modal extends Vue {
  @Prop() public isDisplayed: boolean;

  @Emit('on-close-modal')
  public handleModalClose() {
  } // tslint:disable-line

  @Watch('isDisplayed')
  public onModalToggle() {
    const overflow = this.isDisplayed ? 'hidden' : 'auto';
    document.documentElement.style.overflow = overflow;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Shared/Modal/Modal.vue